export enum TransitionEnum {
  none = 'none',

  validation_masse_salariale = 'validation_masse_salariale',
  validation_sbtcp = 'validation_sbtcp',
  validation_drh = 'validation_drh',

  validation_commission = 'validation_commission',
  validation_acceptee_commission = 'validation_acceptee_commission',
  validation_partielle_commission = 'validation_partielle_commission',

  retour_commission = 'retour_commission',
  annulation_decision_commission = 'annulation_decision_commission',

  validation_decision_commission_spta = 'validation_decision_commission_spta',
  validation_decision_commission_spte = 'validation_decision_commission_spte',

  validation_spta = 'validation_spta',

  recrutement_interne_sans_publication = 'recrutement_interne_sans_publication',
  recrutement_interne_externe = 'recrutement_interne_externe',
  recrutement_interne = 'recrutement_interne',
  recrutement_externe = 'recrutement_externe',

  recrutement_publication = 'recrutement_publication',

  publication_spta_traitement = 'publication_spta_traitement',
  spta_traitement_clos = 'spta_traitement_clos',

  recrutement_spte = 'recrutement_spte',
  spte_traitement_clos = 'spte_traitement_clos',

  demande_refusee = 'demande_refusee',

  archived = 'archived'
}
